export default "__VITE_ASSET__Boajq_SL__"